import React, { lazy } from 'react';

const Summary = lazy(() => import('../screens/Main/Dashboard/SummaryTab'));
const Company = lazy(() => import('../screens/Main/Dashboard/Company/Company'));
const MyCell = lazy(() => import('../screens/Main/Dashboard/MyCellTab'));
const MyPerformance = lazy(() => import('../screens/Main/Dashboard/MyPerformanceTab'));
const EmployeeAnalysis = lazy(() =>
  import('../screens/Main/Dashboard/EmployeeAnalysisTab/EmployeeAnalysisTab'),
);
const Calendar = lazy(() => import('../screens/Main/CalendarNotification/CalendarDashboardView'));

const dashboardRoutes = [
  { path: '/', element: <Summary />, label: 'SUMMARY', value: 0 },
  { path: '/company', element: <Company />, label: 'COMPANY', value: 1 },
  { path: '/my-cell', element: <MyCell />, label: 'MY CELL', value: 2 },
  {
    path: '/my-performance',
    element: <MyPerformance />,
    label: 'MY PERFORMANCE',
    value: 3,
  },
  {
    path: '/employee-analysis',
    element: <EmployeeAnalysis />,
    label: 'EMPLOYEE ANALYSIS',
    value: 4,
  },
  { path: '/calendar', element: <Calendar />, label: 'CALENDAR', value: 5 },
];

export default dashboardRoutes;
